
<template>
  <div id="app">
    <div class="chart-container">
      <canvas id="mixed-chart"></canvas>
    </div>
    
  </div>
</template>

<script>
import Chart from 'chart.js';

export default {
    data () {
          return {
            
          }
    },
    props:['chartData', 'options'],
    methods: {
      createChart(chartId, chartData, options) {
        const ctx = document.getElementById(chartId);
        new Chart(ctx, {
          type: 'bar',
          data: chartData,
          options: options,
        });
      },
    },
     mounted() {

      if(this.chartData.labels !== undefined){
        // remove '-01' from the date to leave only year and month 
          for (let i=0; i<this.chartData.labels.length; i++){
           this.chartData.labels[i] = this.chartData.labels[i].substring(0, 7)
       }

       this.createChart('mixed-chart', this.chartData, this.options);
      } 
       
       
    }
}
</script>

<style scoped>

.chart-container {
    height:300px
}

</style>